import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Landmark, CreditCard, Wallet, ShoppingBag, Loader2, Check } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ICON = { sepa_debit: Landmark, card: CreditCard, paypal: Wallet, klarna: ShoppingBag };
const eur = (v) => Number(v || 0).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });

// Zahlart vor dem Bezahlen wählen: günstigste zuerst (empfohlen), Aufschlag offen ausgewiesen
export const ZahlartWahl = ({ betrag, onWahl, busy, wahl, zweck = '', hinweis, testId = 'zahlart-wahl' }) => {
  const [opt, setOpt] = useState(null);
  useEffect(() => {
    if (!(betrag > 0)) { setOpt([]); return; }
    axios.get(`${API}/zahlarten/optionen`, { params: { betrag, zweck } }).then((r) => setOpt(r.data.optionen)).catch(() => setOpt([]));
  }, [betrag, zweck]);
  if (!opt) return <div className="flex justify-center py-4"><Loader2 className="w-4 h-4 animate-spin text-[#b8893d]" /></div>;
  if (!opt.length) return null;
  return (
    <div className="space-y-2" data-testid={testId}>
      <p className="text-[11px] tracking-[0.18em] uppercase text-[#7a8a99]">Zahlart wählen</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {opt.map((o) => {
          const Icon = ICON[o.art] || CreditCard;
          const an = wahl === o.art;
          return (
            <button type="button" key={o.art} disabled={!!busy} onClick={() => onWahl(o.art, o)} data-testid={`${testId}-${o.art}`}
              className={`relative text-left rounded-xl border px-3.5 py-3 transition-[border-color,background-color,transform] duration-150 hover:-translate-y-px disabled:opacity-60 ${an ? 'border-[#1B3A5C] bg-[#f5f8fa]' : o.empfohlen ? 'border-[#b8893d] bg-[#fbf7f0]' : 'border-gray-200 bg-white hover:border-[#b8893d]'}`}>
              {o.empfohlen && <span className="absolute -top-2 right-3 text-[9px] tracking-[0.15em] uppercase bg-[#b8893d] text-white px-2 py-0.5 rounded-full" data-testid={`${testId}-${o.art}-empfohlen`}>günstigste · empfohlen</span>}
              <span className="flex items-start gap-3">
                <span className="w-8 h-8 rounded-full bg-white border border-gray-200 text-[#b8893d] flex items-center justify-center shrink-0">{busy === o.art ? <Loader2 className="w-4 h-4 animate-spin" /> : an ? <Check className="w-4 h-4" /> : <Icon className="w-4 h-4" />}</span>
                <span className="flex-1 min-w-0">
                  <span className="block text-sm font-medium text-[#1B3A5C]">{o.name}</span>
                  <span className="block text-[11px] text-[#7a8a99]">{o.hinweis}</span>
                  <span className={`block text-[11px] mt-1 ${o.aufschlag ? 'text-amber-800' : 'text-emerald-700'}`} data-testid={`${testId}-${o.art}-gebuehr`}>{o.aufschlag ? `+ ${eur(o.aufschlag)} Zahlartgebühr` : 'ohne Aufschlag'}</span>
                </span>
                <span className="font-serif text-lg tabular-nums text-[#1B3A5C]" data-testid={`${testId}-${o.art}-endbetrag`}>{eur(o.endbetrag)}</span>
              </span>
            </button>);
        })}
      </div>
      {hinweis && <p className="text-[10.5px] text-[#7a8a99]" data-testid={`${testId}-hinweis`}>{hinweis}</p>}
      {opt.some((o) => o.aufschlag) && <p className="text-[10.5px] text-[#7a8a99]">Die Zahlartgebühr deckt nur die Kosten des Zahlungsdienstes. SEPA-Lastschrift und Karte sind ohne Aufschlag.</p>}
    </div>
  );
};

export default ZahlartWahl;
